import { HomeLayout } from '@/theme/default/layouts'

/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
    // {
    //     path: '/',
    //     name: 'home',
    //     redirect: '/home',
    //     component: HomeLayout,
    //     children: [
    //         {
    //             path: 'home',
    //             name: 'homeIndex',
    //             component: () => import('@/theme/default/views/home/Home')
    //         }
    //     ]
    // },
    {
        path: '/fileView',
        name: 'fileView',
        component: () => import('@/components/common/FileView')
      },
    {
        path: '/aichat',
        name: 'aichat',
        component:()=>import('@/components/tools/AIChat')
    }
]
